import {CustomerGroup} from 'coreStore/data/customer/types';
import Customer from 'coreClasses/customer/Customer';

import {IPersonalizedItemProps} from './IPersonalizedBlock';

/**
 * Returns personalized item by customer group
 * @param personalizedItems List of personalized items
 * @param customerGroup - customer group
 * @returns {IPersonalizedItemProps}
 */
export const getPersonalizedItemByCustomerGroup = (
	personalizedItems: Array<IPersonalizedItemProps>,
	customerGroup: CustomerGroup,
): IPersonalizedItemProps | null => {
	return personalizedItems.find((personalizedItem: IPersonalizedItemProps) => {
		const personalizedCustomerGroups = personalizedItem?.customerGroup?.items || [];

		return personalizedCustomerGroups?.some(group => group && group.id === customerGroup['ID']);
	});
};

/**
 * Returns non personalized item
 * @param personalizedItems List of personalized items
 * @returns {IPersonalizedItemProps}
 */
export const getNonPersonalizedItem = (personalizedItems: Array<IPersonalizedItemProps>): IPersonalizedItemProps | null => {
	return personalizedItems.find((personalizedItem: IPersonalizedItemProps) => !personalizedItem?.customerGroup);
};

/**
 * Retrieves personalized item from collection of items according to the current customer session
 * @param personalizedItems List of personalized items configs
 * @returns {IPersonalizedItemProps}
 */
export const getPersonalizedItemForCurrentCustomer = (
	personalizedItems: Array<IPersonalizedItemProps>,
	customer: Customer,
): IPersonalizedItemProps | null => {
	const customerGroups: Array<CustomerGroup> = customer?.customerGroups;

	if (!personalizedItems) {
		return null;
	}

	if (!customerGroups) {
		return getNonPersonalizedItem(personalizedItems);
	}

	let personalizedItemForCurrentCustomer: IPersonalizedItemProps;

	for (const customerGroup of customerGroups) {
		const personalizedItem = getPersonalizedItemByCustomerGroup(personalizedItems, customerGroup);

		if (personalizedItem) {
			personalizedItemForCurrentCustomer = personalizedItem;

			break;
		}
	}

	if (personalizedItemForCurrentCustomer === undefined) {
		personalizedItemForCurrentCustomer = getNonPersonalizedItem(personalizedItems);
	}

	return personalizedItemForCurrentCustomer;
};
